import { IFileUpload } from "./IFileUpload";
import { txt } from "./txt";
import { useState, useContext } from "react";
import { AppContext } from '../ApplicationContext';

export interface IFileUploadGalleryItemProps {
    file: IFileUpload
    onDelete: (file: IFileUpload) => void
}


const FileUploadImagePreview = ( props : { file: IFileUpload } ) => {
    

      let reader = new FileReader()

      reader.readAsDataURL(props.file.LocalFile);

      reader.onloadend = function() {
        
        setData( reader.result );
        setLoading( false );
       
      }


      const [loading, setLoading] = useState(false);
      const [data, setData] = useState(null);


    return <>
            <div className="mr-file-upload-preview mr-file-upload-preview-image">
                   {(!loading) && <div>
                       <img src={data} className="rounded float-start img-fluid" alt={ props.file.LocalFile.name }/>                    </div> }
            </div>
        </>
}


const FileUploadVideoPreview = ( props : { file: IFileUpload } ) => {
    

      let reader = new FileReader()

      reader.readAsDataURL(props.file.LocalFile);

      reader.onloadend = function() {
        
        setData( reader.result );
        setLoading( false );
       
      }


      const [loading, setLoading] = useState(false);
      const [data, setData] = useState(null);


    return <>
            <div className="mr-file-upload-preview mr-file-upload-preview-video">
                   {(!loading) && <div>
                       <video src={data}  autoPlay={false} controls/>                    </div> }
            </div>
        </>
}

const FileUploadAudioPreview = ( props : { file: IFileUpload } ) => {
    

      let reader = new FileReader()

      reader.readAsDataURL(props.file.LocalFile);

      reader.onloadend = function() {
        
        setData( reader.result );
        setLoading( false );
       
      }


      const [loading, setLoading] = useState(false);
      const [data, setData] = useState(null);


    return <>
            <div className="mr-file-upload-preview mr-file-upload-preview-audio">
                   {(!loading) && <div>
                       <audio src={data} autoPlay={false} controls  />                    </div> }
            </div>
        </>
}




const FileUploadDocumentPreview = ( props : { file: IFileUpload } ) => {
    
    const mapIcon = ( m: IFileUpload ) => {
    
        switch(m.LocalFile.type.toLowerCase()) {

                case "application/pdf":
                    return "bi bi-filetype-pdf";
                case "application/doc":
                    return "bi bi-filetype-doc";
                case "application/docx":
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return "bi bi-filetype-docx";
                case "application/xls":
                    return "bi bi-filetype-xls";
                case "application/xlsx":
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return "bi bi-filetype-xlsx";
                case "application/ppt":
                    return "bi bi-filetype-ppt";
                case "application/pptx":
                    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                    return "bi bi-filetype-pptx";
                default:
                    return "bi bi-file";

        }
    }
    console.log("file",{props:props});
    return <>
            <div className="mr-file-upload-preview mr-file-upload-preview-document">
            <div className="row  align-items-center">
                 <div className="col col-auto">
                       <i className={mapIcon(props.file)}/>
                    </div>
                    <div className="col">
                        <span>{props.file.LocalFile.name}</span>
                    </div>
                    </div>
            </div>
        </>
}


const FileUploadPreviewNone = ( props : {file: IFileUpload } ) => {
        return <>
            <div className="mr-file-upload-preview mr-file-upload-preview-none">
                {txt.get.fileUploadGalleryItemNoPreviewAvailable}
            </div>
            </>
}

export const FileUploadGalleryItem = (props:IFileUploadGalleryItemProps) => {

     const context = useContext(AppContext);

    //const [file] = useState<IFileUpload>(props.file);

    //const [uploadedBytes, setUploadedBytes] = useState(0);

    const mapFileType = (m:IFileUpload) => {
    
        if(context.messenger.connection.settings.mimeTypes.video.includes(m.LocalFile.type)) {
            return <FileUploadVideoPreview file={m} />;
        } else if(
                    context.messenger.connection.settings.mimeTypes.image.includes(m.LocalFile.type)
                ||  context.messenger.connection.settings.mimeTypes.sticker.includes(m.LocalFile.type)
        ) 
        
        {
            return <FileUploadImagePreview file={m} />;
        
        } else if(context.messenger.connection.settings.mimeTypes.document.includes(m.LocalFile.type)) {
            
            return <FileUploadDocumentPreview file={m} />;
        
        } else if (context.messenger.connection.settings.mimeTypes.audio.includes(m.LocalFile.type)) {
            
            return <FileUploadAudioPreview file={m} />;

        } else {

            return <FileUploadPreviewNone  file={m} />;

        }
        /*
            switch(m.LocalFile.type.toLowerCase()) {

                case "image/png":
                case "image/jpg":
                case "image/jpeg":
                    return <FileUploadImagePreview file={m} />
                
                case "application/pdf":
                case "application/doc":
                case "application/docx":
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                case "application/xls":
                case "application/xlsx":
                case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                case "application/ppt":
                case "application/pptx":
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return <FileUploadDocumentPreview file={m} />

                default:
                    return <FileUploadPreviewNone  file={m} />


            }
            */
    }


    return <>

        <div  className="mr-file-upload-gallery-item" data-mr-contenttype={props.file.LocalFile.type}>
         <button type="button" className="btn btn-outline-danger btn-sm mr-file-upload-gallery-item-delete" onClick={(e)=>{props.onDelete(props.file)}}><i className="bi bi-x"/></button>
        <div className="row">
            
        <div className="col">
            {mapFileType(props.file)}
        </div>

        
            </div>
        </div>

    </>

}
